import { ScreenBase } from "@frui.ts/screens";

export default class AboutViewModel extends ScreenBase {
  constructor() {
    super();
    this.navigationName = "o-vcelnici";
    this.name = "O včelnici";
  }
}
